// ======================================================================
// File Name       : ContentDistributionUsageSearch
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, Button, InputGroup } from 'react-bootstrap';
import Datetime from 'react-datetime';
import moment from 'moment';
import DateTimeWithValidate from '../DateTimeWithValidate';
import DateTimeMinMax from '../DateTimeMinMax';
import { MIN_DATE, MAX_DATE, MIN_MAX_DATE_TXT, WRONG_DISTRIBUTION_DATE_TXT } from '../../utils/index';
import { DEFAULT_DATE_FORMAT } from '../../constants/index';
import CustomButton from '../button/CustomButton';

class ContentDistributionUsageSearch extends React.Component {
  constructor(props) {
    super(props);
    this.validation = this.validation.bind(this);
  }
  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }
  render() {
    this.refsToValidate = [];
    const {
      name,
      publicStatus,
      contentType,
      acquisitionStartDate,
      acquisitionEndDate,
      onInputChange,
      onSearchBtnClick,
      filterData,
      dateTimeObj,
    } = this.props;
    const onChange = (event) => {
      const { name, value } = event.target;
      onInputChange(name, value);
    };
    return (
      <div>
        <Form.Group className="form-info">
          <Col sm={3} className="margin-left-clear">
              利用状況表示期間
            </Col>
          <Col sm={3}>
            <DateTimeWithValidate
              onChange={moment => onInputChange('acquisitionStartDate', moment)}
              ref={(ref) => {
                if (ref) {
                  this.refsToValidate.push(ref);
                }
              }}
              dateFormat={DEFAULT_DATE_FORMAT}
              value={acquisitionStartDate}
            />
          </Col>
          <Col sm={1} className="text-center" as={Form.Label}>
              ～
            </Col>
          <Col sm={3}>
            <DateTimeWithValidate
              onChange={moment => onInputChange('acquisitionEndDate', moment)}
              ref={(ref) => {
                if (ref) {
                  this.refsToValidate.push(ref);
                }
              }}
              dateFormat={DEFAULT_DATE_FORMAT}
              value={acquisitionEndDate}
              disableCurrentDate
            />
          </Col>
        </Form.Group>
        <Col sm={12}>
          <DateTimeMinMax
            dateFrom={acquisitionStartDate}
            dateTo={acquisitionEndDate}
            ref={(ref) => {
              if (ref) {
                this.refsToValidate.push(ref);
              }
            }}
            wrongPeriodTxt={WRONG_DISTRIBUTION_DATE_TXT}
          />
        </Col>
        <Form.Group className="form-info text-center">
          <Col sm={12}>
            {/* <Button bsStyle="primary" className="btn-96" onClick={onSearchBtnClick}>
                
            </Button> */}
            <CustomButton
              btnStyle="btn btn-primary btn-96"
              handleClick={onSearchBtnClick}
              text="検索"
              iconClass="bi bi-search"
            />
          </Col>
        </Form.Group>
      </div>
    );
  }
}

export default ContentDistributionUsageSearch;
